import { InputText } from "primereact/inputtext"
import { getFormErrorMessage, isFormFieldValid } from "../../utils/formHelper"
import { classNames } from "primereact/utils"
import { FormikValues } from "formik";

type Props = {
    disabled: boolean;
    formik: FormikValues;
    label: string;
    value: string;
    uppercase?: boolean;
}

export const FormInputText = (props: Props) => {
    const { disabled, formik, label, value, uppercase } = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (uppercase) {
            e.target.value = e.target.value.toUpperCase();
        }
        formik.handleChange(e);
    };

    return (
        <div className="field">
            <span className="p-float-label">
                <InputText id={value} name={value} value={formik.values[value] || ""} onChange={handleChange} 
                    disabled={disabled} className={classNames("w-full", { 'p-invalid': isFormFieldValid(value, formik) })} />
                <label htmlFor={value} className={classNames({ 'p-error': isFormFieldValid(value, formik) })}>{label}</label>
            </span>
            {getFormErrorMessage(value, formik)}
        </div>
    )
}